import { render, staticRenderFns } from "./AddMT5CheckPassword.vue?vue&type=template&id=4a8ec7c7&"
import script from "./AddMT5CheckPassword.vue?vue&type=script&lang=js&"
export * from "./AddMT5CheckPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports